<template>
  <div class="mb-4">
    <div class="sample-database-detail dashboard-card">
      <div class="sample-database-detail-body cs-scroll-style">
        <b-row>
          <b-col cols="12" class="mb-4">
            <div class="title-header">
              <h5>{{ 'Genetic Profile' }}</h5>
            </div>
            <div class="p-1">
              <h5 v-if="!farmerHgResultList">Unavailable</h5>
              <template v-else>
                <div v-for="itemAncestry in farmerHgResultList.outPuts" :key="itemAncestry.resultsTable" class="farmer-hgs mb-1">
                  <span class="label">{{ itemAncestry.resultsTable.replaceAll('*', ' ') }} :</span>
                  <span class="percent"><b>{{ itemAncestry.currentResult.toFixed(1) }}%</b></span>
                </div>
              </template>
            </div>
          </b-col>
          <b-col cols="12">
            <SampleDetailTable />
          </b-col>
        </b-row>
        <!-- <hr class="ancient-hr"/> -->
      </div>
    </div>
  </div>
</template>

<script>
import SampleDetailTable from '../SampleDetailTable.vue';

export default {
  components: {
    SampleDetailTable,
  },
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    back() {
      this.$store.state.ancientIndividualDatabase.sampleDetail = null
    },
  },
  computed: {
    popData() {
      return this.$store.state.ancientIndividualDatabase.sampleDetail;
    },
    samples() {
      return this.popData.samples ? this.popData.samples.split(',') : [];
    },
    mtDna() {
      return this.popData.mtDna ? this.popData.mtDna.split(',') : [];
    },
    yDna() {
      return this.popData.yDna ? this.popData.yDna.split(',') : [];
    },

    farmerHgResultList() {
      return this.$store.state.sampleDatabase.calculatedFarmerHgResult;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.sample-database-detail {
  background-color: var(--white-100);
}
</style>
